import React, { forwardRef } from 'react';
import { TOCItem } from '../pages/HubspotCROGuide';
interface StickyTOCProps {
  items: TOCItem[];
  activeId: string;
  onItemClick: (id: string) => void;
  isVisible: boolean;
}
export const StickyTOC = forwardRef<HTMLDivElement, StickyTOCProps>(function StickyTOC({
  items,
  activeId,
  onItemClick,
  isVisible
}, ref) {
  return <div ref={ref} className={`sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm transition-opacity duration-200 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} aria-hidden={!isVisible} data-id="element-78">
        <div className="max-w-6xl mx-auto px-4" data-id="element-79">
          <nav className="py-3" aria-label="Sticky table of contents" data-id="element-80">
            <div className="overflow-x-auto" data-id="element-81">
              <ul className="flex space-x-6 whitespace-nowrap" data-id="element-82">
                {items.map(item => <li key={item.id} data-id="element-83">
                    <a href={`#${item.id}`} className={`inline-block py-2 border-b-2 hover:text-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 rounded ${activeId === item.id ? 'text-orange-600 font-medium border-orange-600' : 'text-gray-700 border-transparent'}`} onClick={e => {
                e.preventDefault();
                onItemClick(item.id);
              }} aria-current={activeId === item.id ? 'true' : undefined} data-id="element-84">
                      {item.text}
                    </a>
                  </li>)}
              </ul>
            </div>
          </nav>
        </div>
      </div>;
});